import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { IntroductionActions } from './introduction.actions';
import { IIntroductionState } from './introduction.state';

export const initialIntroductionState: IIntroductionState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const introductionReducerFn = createReducer(
  initialIntroductionState,
  on(IntroductionActions.reset, (state: IIntroductionState, action) => {
    return new StateBuilder<IIntroductionState>(initialIntroductionState).build();
  }),
  on(IntroductionActions.load, (state: IIntroductionState, action) => {
    return new StateBuilder<IIntroductionState>(state).toLoading().build();
  }),
  on(IntroductionActions.loadSuccess, (state: IIntroductionState, action) => {
    return new StateBuilder<IIntroductionState>(state, action).toLoaded().build();
  }),
  on(IntroductionActions.submit, (state: IIntroductionState, action) => {
    return new StateBuilder<IIntroductionState>(state).toLoading().build();
  }),
  on(IntroductionActions.submitSuccess, (state: IIntroductionState, action) => {
    return new StateBuilder<IIntroductionState>(state, action).toLoaded().build();
  })
);

export function introductionReducer(state: IIntroductionState | undefined, action: Action) {
  return introductionReducerFn(state, action);
}
